import { useLocalStorage } from '@vueuse/core'

/**
 * Локаль vue-i18n в localStorage (@vueuse/core).
 * TODO: предпочтительная локаль — с бэка (профиль / SSO); localStorage временно.
 */
export const LOCALE_STORAGE_KEY = 'ltms-locale'
export const LOCALE_BY_USER_STORAGE_KEY = 'ltms-locale-by-user'

export function normalizeAppLocale(v) {
  return v === 'en' || v === 'ru' ? v : 'ru'
}

export function isGlobalTeamUser(user) {
  return Boolean(user?.ltms_global_team ?? user?.is_global_team)
}

export function defaultLocaleForUser(user) {
  return isGlobalTeamUser(user) ? 'en' : 'ru'
}

/** Реактивная привязка к localStorage (можно импортировать для `watch` и т.п.). */
export const appLocaleStorage = useLocalStorage(LOCALE_STORAGE_KEY, 'ru', {
  serializer: {
    read: raw => {
      if (raw == null || raw === '') return 'ru'
      return normalizeAppLocale(typeof raw === 'string' ? raw : String(raw))
    },
    write: v => normalizeAppLocale(v),
  },
})

export const localeByUserStorage = useLocalStorage(LOCALE_BY_USER_STORAGE_KEY, {})

export function readStoredAppLocale() {
  return appLocaleStorage.value
}

/** Записывает локаль в localStorage и возвращает нормализованный код. */
export function persistAppLocale(code) {
  const n = normalizeAppLocale(code)
  appLocaleStorage.value = n
  return n
}

/** Локаль для пользователя: сохранённый выбор в текущей сессии или дефолт (en для глобальной команды). */
export function resolveLocaleForUser(user) {
  const userId = user?.id
  if (!userId) {
    return readStoredAppLocale()
  }

  const perUser = localeByUserStorage.value?.[String(userId)]
  if (perUser) {
    return persistAppLocale(perUser)
  }

  return persistAppLocale(defaultLocaleForUser(user))
}

/**
 * Сбрасывает локаль к дефолту для пользователя (en — глобал, ru — не глобал)
 * и удаляет сохранённый выбор из localStorage.
 */
export function resetLocaleToDefaultForUser(user) {
  const userId = user?.id
  if (userId != null) {
    const key = String(userId)
    const byUser = { ...localeByUserStorage.value }
    if (key in byUser) {
      delete byUser[key]
      localeByUserStorage.value = byUser
    }
  }
  return persistAppLocale(defaultLocaleForUser(user))
}

/** Явный выбор языка в переключателе — запоминается до следующей авторизации. */
export function persistUserLocalePreference(userId, code) {
  const locale = persistAppLocale(code)
  if (userId != null) {
    localeByUserStorage.value = {
      ...localeByUserStorage.value,
      [String(userId)]: locale,
    }
  }
  return locale
}
